// extracted by mini-css-extract-plugin
module.exports = {"invalidInput":"ErrorLabelSlot_invalidInput__wW6XJ","yellowLabel":"ErrorLabelSlot_yellowLabel__2DsH3","greenLabel":"ErrorLabelSlot_greenLabel__30Sjp"};